<template>
	<el-dialog title="查询服务商信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div class="grid-height">

					<div class="table_main" style="height: 400px!important;">
						<vxe-grid ref="table-m1" :radio-config="{ highlight: true }" @cell-click="cellClickEvent"
							@radio-change="radioChangeEvent" show-overflow height="390" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">
<!--                <template #xxxx="{ row }">

                                              &lt;!&ndash; <div> &ndash;&gt;
                 <el-checkbox  :name="row.id" label="isSendSite"  >网点</el-checkbox>
                 <el-checkbox  :name="row.id" label="isSendUser"  >客户</el-checkbox>
               </template>-->
							<template #form style="">
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="searchEvent" @reset="searchEvent">
									<vxe-form-item title="服务商名称:" field="siteName">
										<template v-slot>
											<el-input v-model="formData.siteName" size="small" clearable />
										</template>
									</vxe-form-item>

                  <vxe-form-item title="跨区域派单:">
                    <template v-slot>
                      <el-radio-group v-model="formData.isCrossRegionDispatch" @change="radioHandleChange">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                      </el-radio-group>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="地区:" field="name" v-if="isShowArea">
                    <template v-slot>
                      <el-cascader :props="areaProps" v-model="formData.areaId" :clearable="true" style="width:9vw ;"
                                   @change="handleAreaChange" ref="cascaderAddr" />
                    </template>
                  </vxe-form-item>

								</vxe-form>
								<div class="clearfix screen-btns" style="">
									<div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>

							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import store from "@/store";
import request from "@/router/axios";
export default {
	name: 'siteDialog',
	props: ['visiable', 'multi', 'param','orderId','assginType'],
	mixins: [selectDialogMixins],
	components: { pager },


  computed: {
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },

	created() {
	  this.formData.orderId = this.orderId?this.orderId:"",
    this.callBackAssignType = this.assginType?this.assginType:0
		this.initSetting();
    this.getCompanyMsg();
	},

	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		total(newVal, oldVal) {
			this.$refs.pager.tableDataTotal = newVal
		}
	},

	data() {
		return {
      isShowArea: false,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      companyMsg: {},
			total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			isRouterAlive: true,
      callBackAssignType:0,
			// 查询参数
			formData: {
				size: 0,
				current: 1,
				searchCount: false,
        wishBookDate:this.param?this.param.wishBookDate?this.param.wishBookDate:"":"",
        areaId : this.param?this.param.areaId?this.param.areaId:'':'',
        brandId : this.param?this.param.brandId?this.param.brandId:'':'',
        smallCategoryId : this.param?this.param.smallCategoryId?this.param.smallCategoryId:'':'',
        isCrossRegionDispatch: 0,
			},
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			selectedRow: {
			}
		};
	},


	methods: {
    getCompanyMsg() {
      request({
        url: '/basic/soOrderIssue/getCompanyMsg',
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.companyMsg = response.data.data
        console.log("对应厂商信息-------",this.companyMsg)
      })
    },

		flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},

		cellClickEvent(e) {

		},


		radioChangeEvent({ row }) {
			this.selectedRow = { id: row.id, name: row.userName,callBackAssignType:this.callBackAssignType }
		},


		commitRow() {
			this.$mask.open()

          // 点击确定  选择了那些值
      var nameId = this.selectedRow.id;
			if(!nameId){
        this.$mask.close()
        this.$message.error('请先选择需要指派的服务商！')
        return
      }
			var obj = document.getElementsByName(nameId);
			var s = '';
			for (var i = 0; i < obj.length; i++) {
				if (obj[i].checked) s += obj[i].value + ',';
        if (obj[i].checked){
          if(obj[i].value == "isSendSite"){
            this.selectedRow.isSendSite = 1;
          }else if(obj[i].value == "isSendUser"){
            this.selectedRow.isSendUser = 1
          }
        }
			};
			this.$emit('commitSiteRow', this.selectedRow),
				this.dialogClose()
				this.$mask.close()

		},


		// 分页功能
		changeTablePage(page, flag) {
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},

		// 重置
		resetEvent() {
			this.formData.siteName = ''
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
			this.reloadTree()
		},



		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: api.soOrder.getAssignSiteUrl,
				param: this.formData,
				method: 'post',
				columns: [
					{ type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
					{ type: "seq", width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '服务商名称',
						field: 'userName',
						width: 110,
						// fixed: 'left'
					},
					{
						title: '性质',
						field: 'siteTypeName',
						width: 110,
					},
					{
						title: '所属机构 ',
						field: 'orgName',
						width: 110,
					},
					{
						title: '地区',
						field: 'userAddress',
						width: 150,
					},
					{
						title: '等级',
						field: 'siteLevelName',
						width: 110,
					},
					{
						title: '未完工量',
						field: 'unFinishOrders',
						width: 110,
					},
					{
						title: '预约日工单量',
						field: 'needFinishOrders',
						width: 110,

					},
					/*{
						field: '',
						title: '短信',
						width: 180,
						slots: {
              default : "xxxx"
						}
					},*/


				]
			};
			this.vxeOption = initVxeTable(tableOption);
			this.flushed()
		},



		// 加载页面
		loadChildNode(node, resolve) {
			fetchTree({
				parentId: node.data.id,
				categoryType: 1
			}).then(({ data }) => {
				console.log(data, "data.data的值"),
					resolve(
						data.data.map(item => {
							return {
								label: item.categoryName,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});
		},


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },


    radioHandleChange(val) {
      console.log(val, "选择的val");
      this.radioHandle = val
      if (val == 1) {
        this.isShowArea = true
      } else {
        this.isShowArea = false
        this.formData.areaId = null
      }
    },

	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 400px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	// width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
	font-size: 14px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: -38px !important;
    position: absolute !important;
    z-index: 9999999;
    background-color: #ffffff;
}
::v-deep .vxe-grid .vxe-form--item .vxe-form--item-title {
    width: 7vw !important;
}
</style>
